// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:41:10

export default {
  "id": "royal-jewels-match",
  "slug": "royal-jewels-match",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/96dbf0d0323d48399eeea3a131b63c5a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/96dbf0d0323d48399eeea3a131b63c5a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Royal Jewels Match",
      "description": "Matching jewels has never been so much fun! Unlock unique levels, participate in special events and take on surprising challenges. Collect coins with your matches and show off your decorating skills. Earn crowns as you progress and become a true master of the game!\n",
      "instructions": "The goal of the game is to match three or more jewels of the same type to complete levels and earn coins. Use your coins to purchase unique decorations, and for every purchase, you'll earn crowns that help you unlock the next exciting adventure!\n",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "combine",
        "king",
        "logic",
        "match3",
        "matching"
      ]
    },
    "zh-CN": {
      "title": "皇家宝石配对",
      "description": "匹配宝石从未如此有趣！解锁独特关卡，参与特别活动，接受令人惊讶的挑战。用你的匹配收集硬币，展示你的装饰技巧。随着进度获得王冠，成为真正的游戏大师！",
      "instructions": "游戏目标是匹配三个或更多相同类型的宝石以完成关卡并获得金币。使用你的金币购买独特装饰，每次购买你都将获得王冠，这些王冠有助于你解锁下一个激动人心的冒险！",
      "genres": [
        "三消匹配"
      ],
      "tags": [
        "组合",
        "国王",
        "逻辑",
        "三消",
        "匹配"
      ]
    },
    "zh-TW": {
      "title": "皇家珠寶配對",
      "description": "匹配寶石從未這麼有趣！解鎖獨特關卡，參與特殊活動，挑戰驚人的挑戰。用你的匹配收集硬幣，展現你的裝飾技巧。隨著進度獲得冠軍，成為遊戲真正的大師！",
      "instructions": "遊戲的目標是匹配三顆或以上的同種寶石來完成等級並獲得硬幣。使用你的硬幣購買獨特的裝飾品，並且每次購買都會獲得冠軍，這將幫助你解鎖下一個令人興奮的冒險！",
      "genres": [
        "配對3"
      ],
      "tags": [
        "合併",
        "王",
        "邏輯",
        "三消匹配",
        "匹配"
      ]
    },
    "zh-HK": {
      "title": "皇家寶石配對",
      "description": "配對寶石從未這麼好玩！解鎖獨特關卡，參與特別活動，挑戰驚人的挑戰。用配對收集硬幣，展現你的裝飾技巧。隨著進展獲得王冠，成為遊戲的真正大師！",
      "instructions": "遊戲的目標是匹配三顆或以上的同種寶石，以完成關卡並獲得硬幣。使用你的硬幣購買獨特的裝飾品，每次購買都會獲得皇冠，這些皇冠有助你解鎖下一個刺激的冒險！",
      "genres": [
        "Match 3"
      ],
      "tags": [
        "合體",
        "王",
        "邏輯",
        "三消配對",
        "配對"
      ]
    },
    "ja": {
      "title": "ロイヤル・ジュエルズ・マッチ",
      "description": "宝石を合わせることは今ほど楽しくなかった！ユニークなレベルを解錠し、特別なイベントに参加し、驚きの挑戦に挑む。一致させることでコインを収集し、装飾のスキルを披露しよう。進むにつれて王冠を獲得し、ゲームの達人になる！",
      "instructions": "ゲームの目標は、同じ種類の宝石を3つ以上連結させてレベルを完了し、コインを獲得することです。コインを使ってユニークな装飾品を購入し、毎回の購入で冠を獲得し、次のスリリングなアドベンチャーを解鍵する助けとなります！",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "コンバイン",
        "キング",
        "ロジック",
        "マッチ3",
        "マッチング"
      ]
    },
    "ko": {
      "title": "로얄 조각 매치",
      "description": "예뻐 보이는 보석을 맞추는 것은 이렇게 재미있지 않았습니다! 독특한 레벨을 해금하고 특별한 이벤트에 참여하고 놀라운 도전을 맞이하세요. 맞춘 보석으로 동전을 모으고 장식 능력을 자랑하세요. 진행하면서 왕관을 얻고 게임의 진정한 마스터가 되세요!",
      "instructions": "게임의 목표는 같은 종류의 보석을 세 개 이상 일치시켜 레벨을 완료하고 동전을 얻는 것입니다. 동전을 사용하여 독특한 장식을 구매하십시오. 모든 구매에 대해 왕관을 얻으며, 이 왕관은 다음 흥미로운 모험을 해봄에 도움이 됩니다!",
      "genres": [
        "매치-3"
      ],
      "tags": [
        "combine",
        "킹",
        "로직",
        "매치3",
        "매칭"
      ]
    },
    "fr": {
      "title": "Royal Jewels Match\nJeux de correspondance des joyaux royaux",
      "description": "La correspondance des pierres précieuses n'a jamais été aussi amusante ! Débloquez des niveaux uniques, participez à des événements spéciaux et affrontez des défis surprenants. Collectez des pièces avec vos correspondances et montrez vos talents de décoration. Gagnez des couronnes au fur et à mesure de votre progression et devenez un véritable maître du jeu !",
      "instructions": "L'objectif du jeu est de matching trois ou plus de bijoux du même type pour terminer les niveaux et gagner des pièces. Utilisez vos pièces pour acheter des décorations uniques, et pour chaque achat, vous gagnerez des couronnes qui vous aideront à déverrouiller la prochaine aventure captivante !",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "combiner",
        "roi",
        "logique",
        "match3",
        "correspondance"
      ]
    }
  }
};
